import { memo } from "react";

import { USER_DROPDOWN_GROUP_ID } from "components/MainNavigation/config/useUserDropdownGroup";
import { SUPPORT_GROUP_ID } from "components/MainNavigation/config/useSupportGroupDropdownSaaS";
import useMainNavigationSecondaryItems from "components/MainNavigation/hooks/useSecondaryItems";
import { MainNavigationGroupItem } from "components/MainNavigation/types";

import MainNavigationNavigationItem from "../../elements/NavigationItem";
import MainNavigationFooter from "../Footer";
import MainNavigationUserDropdown from "./UserDropdown";
import MainNavigationSupport from "./Support";

const MainNavigationSecondaryItems = () => {
  const { navigationItems } = useMainNavigationSecondaryItems();

  return (
    <MainNavigationFooter>
      {navigationItems.map((item) => {
        if (item.id === USER_DROPDOWN_GROUP_ID) {
          return <MainNavigationUserDropdown key={item.id} />;
        }

        if (item.id === SUPPORT_GROUP_ID) {
          return <MainNavigationSupport key={item.id} item={item as MainNavigationGroupItem} />;
        }

        return <MainNavigationNavigationItem key={item.id} item={item} />;
      })}
    </MainNavigationFooter>
  );
};

export default memo(MainNavigationSecondaryItems);
